/**
 * Event requests
 */
import API from '@/api/base.js';
import CONFIG from '@/constants/config.js';
export default {
    checkinEventById(id){
        return API.get(`/appevent/checkinevent/?${CONFIG.PARAM_NAME_EVENT_ID}=${id}`,{},`Checking event by ID ${id}`);
    },
    getEventById(id){
        return API.get(`/appevent/checkinevent/?${CONFIG.PARAM_NAME_EVENT_ID}=${id}`,{},`Get event by ID ${id}`);
    },
    readNewEvent(qrData) {
        return API.post('/appuser/readnewevent',qrData,'ReadEvent',true);
    },
    readNewPin(pinData) {
        return API.post('/appuser/readnewpin',pinData,'Read PIN',true);
    },
    getHighscoreByEventId(id){
        return API.get(`/apphighscore/getnewhighscore/eventId/${id}`,{},`Event by ID ${id}`);
    },
    // force bypasses the GET cache (refresh button)
    getEvents(data,force=false){
        let gametype_id=(data && data.gametype_id)?data.gametype_id:CONFIG.GAMETYPE_LBG;
        let axiosConfig=(force)?{cache:{ignoreCache:true}}:{};
        return API.get(`/appevent/getplayerevents/${CONFIG.PARAM_NAME_GAMETYPE_ID}/${gametype_id}`,data,`Events of gametype ${gametype_id}`,true,axiosConfig);
    },
    getPlayerinfo(data){
        return API.get('/appuser/getplayerinfo',data,'Player info');
    },
    setTeamName(data){
        return API.post('/appuser/setteamname',data,'Team Name',true);
    },
    setParticipantNames(data){
        return API.post('/appuser/createparticipants',data,'Participant Names',true);
    },
    getTeamPhoto(data){
        return API.get('/appfileupload/getteamfoto',data,'Team foto');
    },
    getTeamInfo(data){
        return API.get('/appuser/getteaminfo',data,'Team info');
    },
    setTeamLeader(data){
        return API.get('/appuser/setteamleader',data,'Set Team Leader',false);
    }
}